import "./ClassComponentHooks";
import Vue from "vue";
import VModal from "vue-js-modal";
import { App } from "@/views";
import router from "./router";
import { store } from "@/store";
import VueGtm from "vue-gtm";
import { sync } from "vuex-router-sync";
import VueMoment from "vue-moment";
import Toasted from "vue-toasted";
import Vuelidate from "vuelidate";
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import VueExpandableImage from "vue-expandable-image";
import "@mediakind/mkplayer/mkplayer.js";
import "@mediakind/mkplayer/mkplayer-ui.css";
import {
    capitalizeFilter,
    dateToStringFilter,
    displayedStatusFilter,
    yesNoFilter,
} from "@/filters";

Vue.config.productionTip = false;

Vue.use(VModal);
Vue.use(VueMoment);
Vue.use(Toasted, { router });
Vue.use(Vuelidate);
Vue.use(VuelidateErrorExtractor, {
    template: templates.singleErrorExtractor.foundation6,
    messages: {
        required: "{attribute} is required",
        minValue: "{attribute} value must be at least {min}",
        maxValue: "{attribute} value must be less than {max}",
        minLength: "{attribute;} must have at least {min} letters",
        maxLength: "{attribute} must have less than {max} letters",
        minArrayLength: "{attribute} must have at least {min} elements",
        maxArrayLength: "{attribute} must have less than {max} elements",
        email: "Invalid Email",
        integer: "{attribute} must be an integer",
      },
});
Vue.use(VueExpandableImage);
Vue.use(VueGtm, {
    id: "GTM-WMFSLCN",
    defer: false,
    enabled: true,
    debug: false,
    loadScript: true,
    vueRouter: router,
  });

Vue.filter("capitalize", capitalizeFilter);
Vue.filter("dateToString", dateToStringFilter);
Vue.filter("displayedStatus", displayedStatusFilter);
Vue.filter("yesNo", yesNoFilter);

sync(store, router);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
